/**
 * Updates price displayed when stock id changes
 * @module modules/updatePrice
 */

import $ from 'jquery';

import {
  PRICE_BLOCK,
  PRODUCT_BLOCK,
  RANGE_BLOCK,
  CURRENT_PRICE_ELEMENT,
  REGULAR_PRICE_ELEMENT,
  SKIP_PRICE_UPDATE,
  SALE_DISCOUNT_PRICE_ELEMENT,
} from '../lib/constants/pdp';

/**
 * data attributes attached to the price element
 * used to explicitly declare template id's
 */
export const TEMPLATE_REGULAR = 'template-regular';
export const TEMPLATE_ON_SALE = 'template-on-sale';

/**
 * Update price based on selected value.
 * @param {HTMLElement} wrap - Product wrap
 * @param {Object} chosen - Object representing data from selected option of
 * select dropdown (or input for 1 size)
 */
export default function updatePrice({ wrap, chosen = {} }) {
  const { price, regularPrice, isOnSale, saleDiscountPriceFormatted } = chosen;
  let { priceFormatted, regularPriceFormatted } = chosen;
  const $assignedDefectItemPrice = $('#assignedSellableDefectItemPrice');
  const $assignedDefectItemOriginPrice = $('#assignedSellableDefectItemOriginPrice');
  const isAssignedDefectItemPage =
      $assignedDefectItemPrice.length &&
      $assignedDefectItemPrice.val().length > 0 &&
      $assignedDefectItemOriginPrice.length &&
      $assignedDefectItemOriginPrice.val().length > 0;

  // get the price element
  const $priceEl = $(wrap).find(`.${PRODUCT_BLOCK}__${PRICE_BLOCK}:not(.${PRODUCT_BLOCK}__${PRICE_BLOCK}-${RANGE_BLOCK})`);

  if ($priceEl.data(SKIP_PRICE_UPDATE)) {
    return;
  }

  // get the template style from the price element
  let attr = isOnSale ? TEMPLATE_ON_SALE : TEMPLATE_REGULAR;
  if (isAssignedDefectItemPage) {
    attr = TEMPLATE_ON_SALE;
  }
  const templateId = $priceEl.data(attr);

  // get the template
  const template = document.getElementById(templateId);

  if (!template) {
    throw new Error('Price template not found');
  }

  // update price
  const templateContent = document.importNode(template.content, true);

  // if no price-formatted or regular-price-formatted data attributes defined
  if (!priceFormatted) {
    priceFormatted = price;
  }
  if (!regularPriceFormatted) {
    const currencySymbolEl = templateContent.querySelector('span') || { innerHTML: '' };
    regularPriceFormatted = currencySymbolEl.innerHTML + regularPrice;
  }

  const priceEl = templateContent.querySelector(`.${REGULAR_PRICE_ELEMENT}`);
  if (priceEl) {
    priceEl.innerHTML = priceFormatted;
  }

  // update regular price, for on-sale items
  if (isOnSale || isAssignedDefectItemPage) {
    if (isAssignedDefectItemPage) {
      priceFormatted = $assignedDefectItemPrice.val();
      regularPriceFormatted = $assignedDefectItemOriginPrice.val();
    }
    const regularPriceEl = templateContent.querySelector(`.${REGULAR_PRICE_ELEMENT}`);
    const salePriceEl = templateContent.querySelector(`.${CURRENT_PRICE_ELEMENT}`);
    const salePriceDiscountEl = templateContent.querySelector(`.${SALE_DISCOUNT_PRICE_ELEMENT}`);
    salePriceEl.innerHTML = priceFormatted;

    if (regularPriceEl) {
      regularPriceEl.innerHTML = regularPriceFormatted;
    }

    if (salePriceDiscountEl) {
      if (saleDiscountPriceFormatted) {
        salePriceDiscountEl.classList.remove('u-hide');
        const salePriceDiscountTextEl = salePriceDiscountEl.querySelector('strong');
        salePriceDiscountTextEl.innerHTML = saleDiscountPriceFormatted;
      } else {
        salePriceDiscountEl.classList.add('u-hide');
      }
    }
  }

  // inject template into price element
  $priceEl.html(templateContent);
}



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/product-price-update.js